import { RiSearch2Line } from "react-icons/ri";
import '../style/home/H_Search.css';


const H_Search=()=>{

  const change_border_color =()=>{
    document.querySelector(".h-search").style.borderColor="#2E81E8";
    document.querySelector(".h-search-icon").style.color="#2E81E8";
  }

  const back_to_default =()=>{
    document.querySelector(".h-search").style.borderColor="#A2B4CB";
    document.querySelector(".h-search-icon").style.color="#B5B5B5";
  }

  return(
    <div className="h-search">
      <RiSearch2Line className="h-search-icon"/>
      <input type="search" name="h-search-input" id="h-search-input" placeholder="نام آزمون را جستجو کنید :)" onFocus={change_border_color} onBlur={back_to_default}/>
    </div>
  )
}

export default H_Search;